import React from 'react';
import { useI18n } from './i18n';

function OnavList({ sheets, onSelect }) {
  const { t, tc, formatDate } = useI18n();
  if (sheets.length === 0) {
    return <div className="empty-state">{t('onav.list.empty')}</div>;
  }

  return (
    <div className="sheets-list">
      <h2>{t('onav.list.title')}</h2>
      <div className="cards">
        {sheets.map((s) => (
          <div key={s.id} className="card" onClick={() => onSelect(s)}>
            <div className="card-header">
              <h3>{s.wine_name}</h3>
              {s.vintage && <span className="vintage">{s.vintage}</span>}
            </div>
            <div className="card-body">
              {s.producer && <p>{s.producer}</p>}
              {s.wine_type && <p className="area">{tc('wine_type', s.wine_type)} {tc('classification', s.classification)}</p>}
              {s.variant === 'sparkling' && <p className="area">{t('onav.variant.sparkling')}</p>}
              <div className="card-score-final">{s.total}/100</div>
              {s.verdict && (
                <div className={`pairing-badge-sm ${s.verdict}`}>{tc('verdict', s.verdict)}</div>
              )}
            </div>
            <div className="card-footer">
              {formatDate(s.tasting_date) || '—'} {s.taster ? `· ${s.taster}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OnavList;
